import { Component, Input, OnInit } from '@angular/core';
import { FbTabPanelButtonConfiguration } from './fb-tabpanel-button.configuration';

@Component({
  selector: 'fb-tabpanel-button',
  templateUrl: './fb-tabpanel-button.component.html',
  styleUrls: ['./fb-tabpanel-button.component.scss']
})
export class FbTabpanelButtonComponent implements OnInit {

   @Input() configuration!: FbTabPanelButtonConfiguration;

  constructor() { }

  ngOnInit() {
  }

}
